import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetchAccountDetailSuccess } from '@rogers/self-serve-common/account';
import { EMPTY } from 'rxjs';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { UserInformationStateFacade } from '@rci/self-serve-fido/state/user-information/user-information-state.facade';
import { TargetedOffersFacadeService } from '@rogers/self-serve-targeted-offers';
import { updateSelectedAccountNumber } from '@rci/self-serve-fido/state/user-information';
import { AccountDetailService } from '@rci/self-serve-fido/state/account/account-detail.service';
import { LoginStateFacade } from '@rci/self-serve-fido/core/fido-login-state/login-state.facade';

@Injectable()
export class AccountDetailEffects {
  loadTargetedOffers$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(fetchAccountDetailSuccess),
        switchMap(({ accountDetail }) => {
          if (
            accountDetail.isSubscriber ||
            !!accountDetail.error ||
            accountDetail.isTentative ||
            !accountDetail.isWirelessOrConsolidatedAccount ||
            !accountDetail.subscriptions ||
            accountDetail.subscriptions.length === 0
          ) {
            this.targetedOffersFacadeService.addEmptyTargetedOffers(accountDetail.accountNumber);
            return EMPTY;
          }
          const ctnList = accountDetail.subscriptions.map(subscription => subscription.subNumber);
          return this.targetedOffersFacadeService.loadTargetedOffers$({
            accountNumber: accountDetail.accountNumber,
            ctnList,
            accountAlias: accountDetail.alias
          });
        }),
      );
    },
    { dispatch: false },
  );

  fetchSelectedAccountDetail$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(updateSelectedAccountNumber),
        switchMap(() => this.loginStateFacade.isLoggedIn$),
        filter(loggedIn => loggedIn),
        tap(() => {
          this.accountDetailService.fetchSelectedAccountDetail$().pipe(take(1)).subscribe();
        }),
      );
    },
    { dispatch: false },
  );

  constructor(
    private readonly accountDetailService: AccountDetailService,
    private readonly actions$: Actions,
    private readonly loginStateFacade: LoginStateFacade,
    private readonly targetedOffersFacadeService: TargetedOffersFacadeService,
    private readonly userInformationStateFacade: UserInformationStateFacade,
  ) {}
}
